import React, { FC } from 'react';
import omit from 'lodash-es/omit';

import { Box } from '@rover/kibble/core';
import { useTheme } from '@rover/kibble/themes';

import LinkButton from '../LinkButton';
import { NavBarItemProps, NavBarLink } from '../NavBarItem';

const SMALL_ITEM_HEIGHT = '42px';
const LARGE_ITEM_HEIGHT = '50px';

const MenuItem: FC<NavBarItemProps> = ({
  href,
  children,
  icon,
  iconAlignment,
  onClick,
  paddingX = ['2x', '2x', '3x'],
  ...other
}) => {
  const theme = useTheme();
  const commonProps = {
    children: children || '',
    icon,
    iconAlignment,
    onClick,
    paddingX,
  };
  return (
    <Box
      as="li"
      height={[SMALL_ITEM_HEIGHT, SMALL_ITEM_HEIGHT, LARGE_ITEM_HEIGHT]}
      sx={{
        listStyleType: 'none',
        ':hover > *': {
          color: theme.textColor.navigation_hover.toString(),
          textDecoration: 'underline',
          fontWeight: 'semibold',
        },
      }}
      {...omit(other, ['aria-expanded', 'aria-label'])}
    >
      {href ? (
        <NavBarLink href={href} aria-label={other['aria-label']} {...commonProps} />
      ) : (
        <LinkButton
          aria-expanded={other['aria-expanded']}
          aria-label={other['aria-label']}
          {...commonProps}
        />
      )}
    </Box>
  );
};

export default MenuItem;
